import React, { memo, useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';

import { Select } from 'reaxl';
import { sendClick } from 'reaxl-analytics';

import { srpSortDropDownClick } from '@/analytics/srpAnalyticsHandlers';

import inventorySortOptions from '@/config/sort';

import srpSortDuck from '@/ducks/srp/srpSortDuck.js';

import useSrpNavigation from '@/hooks/useSrpNavigation';

function FilterSortDropdownContainer() {
    const dispatch = useDispatch();
    const navigateToSrp = useSrpNavigation();

    const currentSort = useSelector(srpSortDuck.selectors.getDuckState);

    const sortData = { ...inventorySortOptions, value: currentSort };

    const handleSortChange = useCallback(async (event) => {
        const sortType = _get(event, 'target.value', null) || event;

        // set sort based on target value
        dispatch(srpSortDuck.creators.setSort(sortType));
        sendClick(srpSortDropDownClick, event, {
            sortType,
        });
        navigateToSrp({ resetPagination: true, isNewSearch: false });
    }, [dispatch, navigateToSrp]);

    return (
        <Select
            labelProps={{ label: 'Sort By:' }}
            onChange={handleSortChange}
            className="inside-select-label dropdown-select margin-bottom-0"
            data-cmp="filteredResultsSortControl"
            key="filteredResultsSortControl"
            {...sortData}
        />
    );
}

export default memo(FilterSortDropdownContainer);
